import { BasketballTeam } from '@hefe/models';
import {
  BasketballTeamAddPlayersRequest,
  BasketballTeamsSlice,
  BasketballUsersSlice,
  ModalsSlice,
} from '@hefe/store';
import { formatDate } from '@hefe/utils';
import { Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddPlayersToTeamFormProps {
  team: BasketballTeam;
}

export default function AddPlayersToTeamForm(props: AddPlayersToTeamFormProps) {
  const dispatch = useAppDispatch();

  const allUsersSelect = useSelector(
    BasketballUsersSlice.basketballUsersSelectWithBirthdaySelector
  );

  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;

    const submitValues: BasketballTeamAddPlayersRequest = {
      team_id: props.team.id,
      player_ids: values.player_ids,
    };

    dispatch(setLoading(true));
    dispatch(BasketballTeamsSlice.addPlayersToBasketballTeam(submitValues))
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical">
      <CustomForm
        key={`add-players-to-team-form-${props.team.id}`}
        formId={`add-players-to-team-form-${props.team.id}`}
        fields={[
          {
            name: 'player_ids',
            label: t('Spieler'),
            type: 'select',
            multiSelect: true,
            placeholder: t('select'),
            selectOptions: allUsersSelect,
            rules: [
              {
                required: true,
                type: 'array',
                message: t('form_errors.name'),
              },
            ],
          },
        ]}
        onSubmit={onSubmit}
      />
      <Typography.Text>
        {t('information_texts.set_player_settings')}
      </Typography.Text>
    </Space>
  );
}
